<template>
    <section
        class="hero section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="hero-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div
                    class="split-wrap"
                    :class="[
                        invertMobile && 'invert-mobile',
                        invertDesktop && 'invert-desktop',
                        alignTop && 'align-top'
                    ]">
                    <div class="split-item">
                        <div class="hero-content split-item-content center-content-mobile">
                            <h1 class="mt-0 mb-16 reveal-from-left">
                                Upgrade your trading experience
                            </h1>
                            <p class="mt-0 mb-24 reveal-from-left" data-reveal-delay="200">
                                SmartAlgo® is a leading provider of indicators for TradingView.com. Our proprietary trading algorithm will show you the best times to buy and sell for any instrument on any timeframe.
                            </p>
                            <div class="reveal-from-left" data-reveal-delay="400">
                                <!-- <c-button tag="a" color="primary" wide-mobile href="#">
                                    Get started - Free Trial
                                </c-button> -->

                                <anchor-router-link :to="{hash: '#pricing', name: 'home'}" class="button button-primary button-wide-mobile">Get Started - Free Trial</anchor-router-link>
                            </div>
                        </div>
                        <div class="hero-figure is-3d split-item-image illustration-element-01 reveal-scale-up">
                            <c-image
                                class="has-shadow"
                                :src="require('@/assets/images/feature.png')"
                                alt="SmartAlgo Indicator"
                                :width="528"
                                :height="396" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionSplitProps } from '@/utils/SectionProps.js'
// import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'
import AnchorRouterLink from 'vue-anchor-router-link'

export default {
  name: 'CHeroSplit',
  components: {
    // CButton,
    CImage,
    AnchorRouterLink
  },
  mixins: [SectionSplitProps]
}
</script>